import {all, delay, fork, put, takeLatest} from "redux-saga/effects";
import {CREATE_CUSTOMER, DELETE_CUSTOMER, GET_CUSTOMER, GET_CUSTOMERS, UPDATE_CUSTOMER} from "../constants/Customers";
import EstService from "../../services/EstService";
import {
  createCustomerSuccess,
  getCustomers as getCustomersAction,
  getCustomersSuccess,
  getCustomerSuccess
} from "../actions/Customers";
import AlgoliaService from "../../services/AlgoliaService";
import {setLoadingInvisible, setLoadingVisible} from "redux/actions";

export function* getCustomers(){
  yield takeLatest(GET_CUSTOMERS, function* ({page, perPage, search}){
    try {
      if(search && page === 1)
        yield new Promise(resolve => setTimeout(() => resolve(true), 1000))
      const res = yield AlgoliaService.getCustomers({
        query: search,
        hitsPerPage: perPage,
        page: (page - 1)
      })

      const skip = perPage * (page - 1)
      const from = skip + 1
      const to = (skip + perPage > res.data.nbHits) ? res.data.nbHits : skip + perPage
      yield put(getCustomersSuccess(res.data.hits, res.data.nbHits, from, to))
    } catch (err){
      console.log(err)
    }
  })
}

export function* createCustomer(){
  yield takeLatest(CREATE_CUSTOMER, function* ({data, history}){
    try {
      const res = yield EstService.createCustomer(data)
      yield put(createCustomerSuccess(res.data));
      if (history) {
        history.push(`/app/customers/${res.data.account_customer_id}`);
      }
    } catch (err){
      console.log(err)
    }
  })
}

export function* updateCustomer(){
  yield takeLatest(UPDATE_CUSTOMER, function* ({id, data, history}){
    try {
      const res = yield EstService.updateCustomer(id, data)
      history.push(`/app/customers/${res.data.account_customer_id}`)
    } catch (err){
      console.log(err)
    }
  })
}

export function* getCustomer(){
  yield takeLatest(GET_CUSTOMER, function* ({id}){
    try {
      const res = yield EstService.getCustomer(id)
      yield put(getCustomerSuccess(res.data))
    } catch (err){
      console.log(err)
    }
  })
}

export function* deleteCustomer(){
  yield takeLatest(DELETE_CUSTOMER, function* ({id, page, perPage, search}){
    try {
      yield put(setLoadingVisible());
      yield EstService.deleteCustomer(id)
      yield delay(1000)
      yield put(getCustomersAction(page, perPage, search))
      yield put(setLoadingInvisible());
    } catch (err){
      yield put(getCustomersAction(page, perPage, search))
      console.log(err)
      yield put(setLoadingInvisible());
    }
  })
}

export default function* customersSaga() {
  yield all([
    fork(getCustomers),
    fork(getCustomer),
    fork(createCustomer),
    fork(updateCustomer),
    fork(deleteCustomer),
  ]);
}